module.exports = __webpack_public_path__ + "static/img/7伊鸣.ff76845.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/logo/7伊鸣.jpg
// module id = Yd2U
// module chunks = 0